// Module
var code = "<div tabindex=\"0\" (click)=\"backToNBG()\" (keyup.enter)=\"backToNBG()\" class=\"flex-vertical-center cursor-pointer\" style=\"min-height:11rem\" [ngStyle]=\"{\r\n\t\theight: isRebrading ? '' : '11rem'\r\n\t}\"> <img [src]=\"comboLogoSrc\" alt=\"nbg logo\" title=\"nbg logo\" class=\"full-height margin-auto--mobile\"/> </div> ";
// Exports
module.exports = code;